import { Trans } from "@lingui/react/macro";
import type {
    FirewallRule,
    FirewallRuleEndpointSpecType,
    FirewallRuleProtocolType,
} from "@warrenio/api-spec/spec.oats.gen";
import { notNull } from "@warrenio/utils/notNull";
import type { ReactNode } from "react";

export interface RuleType {
    type: string;
    title: ReactNode;
    protocol: FirewallRuleProtocolType[];
    port_start: number;
    port_end?: number;
    isCustom?: boolean;
}

export const ruleTypes: RuleType[] = [
    {
        type: "any",
        title: <Trans>Any</Trans>,
        protocol: ["any"],
        port_start: 0,
    },
    {
        type: "Custom",
        title: <Trans>Custom</Trans>,
        protocol: ["tcp", "udp"],
        port_start: 8000,
        isCustom: true,
    },
    {
        type: "SSH",
        title: "SSH",
        protocol: ["tcp"],
        port_start: 22,
    },
    {
        type: "HTTP",
        title: "HTTP",
        protocol: ["tcp"],
        port_start: 80,
    },
    {
        type: "HTTPS",
        title: "HTTPS",
        protocol: ["tcp"],
        port_start: 443,
    },
    {
        type: "MySQL",
        title: "MySQL",
        protocol: ["tcp"],
        port_start: 3306,
    },
    {
        type: "DNS TCP",
        title: "DNS TCP",
        protocol: ["tcp"],
        port_start: 53,
    },
    {
        type: "DNS UDP",
        title: "DNS UDP",
        protocol: ["udp"],
        port_start: 53,
    },
    {
        type: "All TCP",
        title: <Trans>All TCP</Trans>,
        protocol: ["tcp"],
        port_start: 1,
        port_end: 65535,
    },
    {
        type: "All UDP",
        title: <Trans>All UDP</Trans>,
        protocol: ["udp"],
        port_start: 1,
        port_end: 65535,
    },
    {
        type: "ICMP",
        title: "ICMP",
        protocol: ["icmp"],
        port_start: 0,
    },
    {
        type: "ICMPv6",
        title: "ICMPv6",
        protocol: ["icmp6"],
        port_start: 0,
    },
];

// "group_tag" "vlan" near future
export interface RuleEndpointSpecType {
    type: FirewallRuleEndpointSpecType;
    title: ReactNode;
}

export const ruleEndpointSpecs: RuleEndpointSpecType[] = [
    {
        type: "any",
        title: <Trans>Any</Trans>,
    },
    {
        type: "ip_prefixes",
        title: <Trans>IP prefixes</Trans>,
    },
];

export function getRuleType(item: FirewallRule): ReactNode {
    const { protocol, port_start, port_end } = item;

    for (const rule of ruleTypes) {
        if (rule.protocol.includes(protocol)) {
            const startMatch = rule.port_start === port_start;

            const endMatch = rule.port_end !== undefined ? rule.port_end === (port_end ?? port_start) : true;

            if (startMatch && endMatch) {
                return rule.title;
            }
        }
    }

    const customType = notNull(ruleTypes.find((item) => item.isCustom));
    return customType.title;
}
